import * as React from 'react';
import classnames from 'classnames';
import { EPurchaseCostReviewStatus } from 'services/BookingManagerApi/types';
import { SvgIcon } from 'ui/SvgIcon';
import CheckIcon from 'ui/Icons/tabler/check.component.svg';
import ExclamationCircleIcon from 'ui/Icons/tabler/exclamation-circle.component.svg';

export interface IPurchaseCostReviewStatusProps {
  className?: string;
  status: EPurchaseCostReviewStatus;
}

const ICON_COLORS = {
  [EPurchaseCostReviewStatus.PENDING]: 'fill-yellow-30',
  [EPurchaseCostReviewStatus.APPROVED]: 'approved',
  [EPurchaseCostReviewStatus.REJECTED]: 'fill-red-95',
};

export const PurchaseCostReviewStatus: React.FC<IPurchaseCostReviewStatusProps> = ({ status, className }) => {
  if (!ICON_COLORS[status]) {
    return null;
  }

  if (status === EPurchaseCostReviewStatus.APPROVED) {
    return (
      <SvgIcon
        IconComponent={CheckIcon}
        className={classnames(className, 'purchase-cost-review-status', status, 'w-4 h-4 fill-transparent stroke-teal-100 stroke-2')}
      />
    );
  }

  return (
    <SvgIcon
      IconComponent={ExclamationCircleIcon}
      className={classnames(className, 'purchase-cost-review-status', status, 'w-4 h-4', ICON_COLORS[status])}
    />
  );
};
